import Vue from "vue";
import utc from "dayjs/plugin/utc";
import dayjs from "dayjs";
dayjs.extend(utc);

Vue.filter("datetime", function(value, tz = null) {
  if (value) {
    let date = dayjs(value);

    if (tz == 'utc') {
      date = date.utc(value);
    } else if (tz == 'local') {
      date = date.utc(value).local();
    }

    return date.format("DD-MM-YYYY HH:mm");
  }
});
